import React, { useEffect, useState } from "react";
import { getClassName } from "@utils";
import { Button, ButtonSize, ButtonVariant } from "../Button";
import css from "./ErrorOverlay.module.scss";

export interface ErrorOverlayProps {
  className?: string;
  isOpened: boolean;
  description?: string;
  title?: string;
  buttonText?: string;
  buttonIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
  render?: () => React.ReactNode;
  onClick?: () => void;
}

const ErrorOverlay: React.FC<ErrorOverlayProps> = ({
  className,
  isOpened: isOpenedProp,
  description,
  title,
  buttonText = "Refresh",
  buttonIcon: ButtonIcon,
  render,
  onClick,
}) => {
  const [isOpened, setIsOpened] = useState(isOpenedProp);

  const attrs = {
    container: {
      className: getClassName(css.container, !isOpenedProp && css.containerClosing, className),
      onAnimationEnd: () => {
        if (!isOpenedProp) {
          setIsOpened(false);
        }
      },
    },
    title: {
      className: css.title,
    },
    description: {
      className: css.description,
    },
    button: {
      onClick,
      size: ButtonSize.XS,
      variant: ButtonVariant.Secondary,
      className: css.button,
    },
  };

  useEffect(() => {
    if (isOpenedProp) {
      setIsOpened(true);
    }
  }, [isOpenedProp]);

  if (!isOpened) {
    return null;
  }

  return (
    <div {...attrs.container}>
      {render ? (
        render()
      ) : (
        <>
          {title ? <span {...attrs.title}>{title}</span> : null}
          {description ? <span {...attrs.description}>{description}</span> : null}
          <Button {...attrs.button}>
            <span>{buttonText}</span>
            {ButtonIcon && <ButtonIcon />}
          </Button>
        </>
      )}
    </div>
  );
};

export default ErrorOverlay;
